<div class="form-validation alert alert-danger mb-0">
    <div class="d-flex align-items-center mb-2">
        <div class="form-validation__icon align-self-end">
            <wdx-icon
                class="d-block mt-n1 me-2 text-danger-contrast"
                size="lg"
                [icon]="ICON_WARNING"
                [scale]="1.25"
            ></wdx-icon>
        </div>

        <div class="form-validation__message">{{ message }}:</div>

        <div class="ms-auto">
            <ng-content select="button"></ng-content>
        </div>
    </div>

    <div class="form-validation__list" data-cy="validation-list">
        @if (isArrayOfSections) {
            @for (
                section of $any(validationSummary);
                track $index;
                let last = $last
            ) {
                <div class="d-md-flex align-items-center" [class.mb-2]="!last">
                    @if (section.label) {
                        <span class="me-2">
                            {{ section.label | translateTokenisedString }}:
                        </span>
                    }
                    <div>
                        <ng-container
                            *ngTemplateOutlet="
                                valdationSection;
                                context: { section: section }
                            "
                        ></ng-container>
                    </div>
                </div>
            }
        } @else {
            <ng-container
                *ngTemplateOutlet="
                    valdationSection;
                    context: { section: validationSummary }
                "
            ></ng-container>
        }
    </div>
</div>

<ng-template #valdationSection let-section="section">
    @for (error of section?.errors; track $index; let last = $last) {
        <button
            type="button"
            class="btn btn-link text-start text-danger-contrast"
            [attr.data-cy]="'btn-' + error.name"
            (click)="onErrorClicked(error)"
        >
            <span
                class="validation-summary-label"
                [innerHTML]="
                    error.fieldLabel
                        | translateTokenisedString
                        | markdownToHtml
                        | safeHtml
                "
            ></span>
        </button>
        @if (!last) {
            ,&nbsp;
        }
    }
</ng-template>
